"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserFlags = void 0;
const bowser_1 = __importDefault(require("bowser"));
const getBrowserFlags = (userAgent) => {
    const navBrowser = bowser_1.default.parse(userAgent);
    //the mobile and tablet flags are used to determine layout in SSR. They may have been set already based on cloudfront headers
    if (typeof navBrowser.mobile === "undefined") {
        navBrowser.mobile = Boolean(navBrowser.platform.type === "mobile");
    }
    if (typeof navBrowser.tablet === "undefined") {
        navBrowser.tablet = Boolean(navBrowser.platform.type === "tablet");
    }
    //set some easy to use flags for apps to quickly determine specific devices
    navBrowser.mac = Boolean(navBrowser.os.name === "macOS");
    navBrowser.linux = Boolean(navBrowser.os.name === "Linux");
    navBrowser.ios = Boolean(navBrowser.os.name === "iOS");
    navBrowser.firefox = Boolean(navBrowser.browser.name === "Firefox");
    navBrowser.android = Boolean(navBrowser.os.name === "Android");
    navBrowser.msie = Boolean(navBrowser.browser.name === "Internet Explorer");
    navBrowser.msedge = Boolean(navBrowser.browser.name === "Microsoft Edge");
    return navBrowser;
};
exports.getBrowserFlags = getBrowserFlags;
//# sourceMappingURL=browserUtils.js.map